import React from 'react';
import PropTypes from 'prop-types';

import { reduxForm, Form } from 'redux-form';
import { connect } from 'react-redux';
import { HeadingFive, Button, Card } from 'hui/src/styled';
import { fillContainer, buttonAlignment, disabledButton } from './shared/SharedStyles';
import { EventCategories, EventActions } from '../../../constants/Analytics';
import { trackEvent } from '../../../utils/googleAnalytics';
import SuburbSelect from '../SuburbSelect';

const validate = values => {
  const errors = {};
  if (!values.w) {
    errors.w = `We couldn't figure out where you want the job done`;
  }
  return errors;
};

const LocationStep = ({ handleSubmit, invalid, category }) => (
  <Form onSubmit={handleSubmit} style={fillContainer}>
    <Card m={0} p={1} center style={fillContainer}>
      <HeadingFive mb={1}>Which suburb is the job in?</HeadingFive>
      <SuburbSelect
        label={''}
        name="w"
        placeholder="Postcode and suburb e.g. 2000 - Sydney"
        onChange={() => {
          trackEvent(
            EventCategories.POST_JOB_MODAL,
            EventActions.SELECT_LOCATION,
            category,
            '',
            '',
            false
          );
        }}
      />
      <Button
        disabled={!!invalid}
        type={'submit'}
        m={0.5}
        block
        style={!invalid ? buttonAlignment : disabledButton}
        data-ga-interactive={false}
        data-ga-category={EventCategories.POST_JOB_MODAL}
        data-ga-action={EventActions.PRESS_NEXT_LOCATION_SCREEN}
        data-ga-label={category}
      >
        Next
      </Button>
    </Card>
  </Form>
);

LocationStep.propTypes = {
  handleSubmit: PropTypes.func,
  back: PropTypes.func,
  onSelectLocation: PropTypes.func,
  invalid: PropTypes.bool,
  progress: PropTypes.string,
  category: PropTypes.string
};

const ConnectedStep = reduxForm({
  form: 'GQWIZARD',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(LocationStep);

export default connect()(ConnectedStep);
